import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl } from "../../api/apiClient";
import {
  firstPasswordChangeFailure,
  firstPasswordChangeStart,
  firstPasswordChangeSuccess,
} from "../../store/features/firstPasswordChange/firstPasswordChangeSlice";

const firstChangePasswordApi = async ({ old_password, new_password, uid }) => {
  try {
    const URL = buildApiUrl("/api/v1/user/first-password-change/");
    const response = await axios.post(URL, {
      old_password,
      new_password,
    }, {
      params: { uid },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleFirstPasswordChangeSaga(action) {
  try {
    const data = yield call(firstChangePasswordApi, action.payload);
    yield put(firstPasswordChangeSuccess(data));
  } catch (error) {
    yield put(firstPasswordChangeFailure(error.message));
  }
}

export default function* firstPasswordChangeSaga() {
  yield takeLatest(
    firstPasswordChangeStart.type,
    handleFirstPasswordChangeSaga
  );
}
